import React,  {useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';

import {
    submitSearchFacet,
    clearFilters,
    toggleVisibleDropdownMenu,
} from '../Actions/FacetedSearch.action';

const FacetedSearchCompact = ({ facetFilters, onFacetChange }) => {
    const dispatch = useDispatch();
    const { visibleDropdownMenu } = useSelector((state) => state.facetedSearch);
    const [expandedGroups, setExpandedGroups] = useState([]);

    const toggleExpandGroup = (group) => {
        if(expandedGroups.some(item => item == group.label)){
            setExpandedGroups(expandedGroups.filter(function(activeGroup) {
                return activeGroup !== group.label;
            }))
        }
        else{
        setExpandedGroups([...expandedGroups, group.label]);
        }
    }

    const isExpanded = (group) => {       
        var res = expandedGroups.some(item => item == group.label);
        return res;
    }

    return (
        <div className="faceted-search faceted-search--compact row">
            {facetFilters &&
                facetFilters.map(
                    (group, groupIndex, array) =>
                        group.options &&
                        group.options.length > 0 && (
                            <div
                                className="columns small-12 faceted-search__group"
                                key={`${group.label}-${groupIndex}`}
                            >
                                <div
                                    className={`faceted-search__group-header ${
                                        visibleDropdownMenu.includes(group.id)
                                            ? 'faceted-search__group-header--show-compact'
                                            : ''
                                    }`}
                                    role="faceted-search-item-group"
                                    onClick={(event) =>
                                        dispatch(
                                            toggleVisibleDropdownMenu(group)
                                        )
                                    }
                                >
                                    {group.label}
                                </div>
                                <ul className={isExpanded(group) ? "faceted-search__sublist expanded" : "faceted-search__sublist"}>
                                    {group.options &&
                                        group.options.map(
                                            (item, itemIndex, array) => (
                                                <li
                                                    key={`${item.label}-${itemIndex}`}
                                                    className="faceted-search__item"
                                                    role="faceted-search-item"
                                                >
                                                    <FacetedFilterCheckbox
                                                        item={item}
                                                        group={group}
                                                        onFacetChange={
                                                            onFacetChange
                                                        }
                                                    />
                                                </li>
                                            )
                                        )}
                                    <li className="faceted-search__item">
                                        <button
                                            className="filter__button"
                                            onClick={(event) => {
                                                dispatch(
                                                    toggleVisibleDropdownMenu(
                                                        group
                                                    )
                                                );
                                                dispatch(
                                                    submitSearchFacet(
                                                        facetFilters
                                                    )
                                                );
                                            }}
                                        >
                                            {translate('general.select')}
                                        </button>
                                    </li>
                                </ul>
                                <button onClick={() => toggleExpandGroup(group)}>{isExpanded(group) ? translate('general.showless') : translate('general.showmore')}</button>
                            </div>
                        )
                )}
            <div className="filter-modal__modal-controller-container filter-modal__modal-controller-container--search">
                <div className="filter-controller hide-for-large">{translate('category.close')}</div>
                <div className="filter-modal__modal-controller-wrapper">
                    <div onClick={() => dispatch(clearFilters)}>
                        {translate('category.clearfilter')}</div>
                    <div onClick={() => dispatch(submitSearchFacet(facetFilters))} className="filter-controller small-button">{translate('facet.header.filter')}</div>
                </div>
            </div>
        </div>
    );
};

const decodeAndStrip = (htmlString) => {
    var strippedHtml = htmlString.replace(/<[^>]+>/g, '');
    return strippedHtml;
} 

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
    <label className="faceted-filter">
        <input
            className="faceted-filter__input"
            type="checkbox"
            onChange={(event) => onFacetChange(group, item)}
            checked={group.selectedOptions.includes(item.id)}
        />
        <span className="faceted-filter__label">
            {decodeAndStrip(item.label)}
            {!isNaN(item.quantity) && item.quantity > 0 && (
                <span className="faceted-filter__quantity">
                    {' '}
                    ({item.quantity})
                </span>
            )}
        </span>
    </label>
);

export default FacetedSearchCompact;
